import React from 'react';
import { timeAgo } from '@/utils/ts/stringUtils';
import { useNavigate } from 'react-router-dom';

import ArrowRight from '@/components/Icons/icons/ArrowRight';

import ButtonComponent from '../ButtonComponent/ButtonComponent';
import IconContainer from '../FtuxComponent/IconContainer';

export default function BulkCouponUpdateNotification({ notification }) {
  const navigate = useNavigate();
  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <IconContainer icon="🏷️" bgColor="var(--background-default)" className="small" />
      </div>
      <div className="text-div" style={{ marginLeft: 6 }}>
        <h3 className="title">{notification?.title}</h3>
        <p className="description">{notification?.content?.body}</p>
        <p className="timestamp" style={{ paddingTop: 8 }}>
          {timeAgo(notification?.createdAt)}
        </p>
        {notification?.content?.listId && (
          <div className="btn-container">
            <ButtonComponent
              variant="primary-text"
              className="px-0"
              textStyle={{ fontSize: 14 }}
              onClick={() => {
                navigate(`/dashboard/list/detail/${notification?.content?.listId}`);
              }}
              rightIcon={<ArrowRight color="var(--purple-p-400)" size={20} />}>
              See List
            </ButtonComponent>
          </div>
        )}
      </div>
    </div>
  );
}
